define('contact',["require", "exports", "./util/http"], function (require, exports, http_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var submitButton;
    function init() {
        submitButton = document.getElementById("contact-submit");
        // Initialize form
        if (submitButton) {
            document.getElementById("contact-form").onsubmit = function () {
                var form = getForm();
                if (validate(form)) {
                    // Prevent double sending
                    submitButton.disabled = true;
                    sendEmail(form);
                }
                return false;
            };
        }
    }
    function getForm() {
        var emailInput = document.getElementById("contact-email");
        var messageInput = document.getElementById("contact-message");
        return {
            email: emailInput.value,
            message: messageInput.value
        };
    }
    // Validate form
    function validate(form) {
        document.getElementById("contact-status").classList.remove("text-success");
        document.getElementById("contact-status").classList.remove("text-danger");
        document.getElementById("contact-status").innerText = "";
        document.getElementById("contact-email-group").classList.remove("has-error");
        document.getElementById("contact-message-group").classList.remove("has-error");
        // Validate form
        if (!form.email) {
            document.getElementById("contact-email-group").classList.add("has-error");
            document.getElementById("contact-email").focus();
            return false;
        }
        else if (!form.message) {
            document.getElementById("contact-message-group").classList.add("has-error");
            document.getElementById("contact-message").focus();
            return false;
        }
        else {
            return true;
        }
    }
    // Send email via POST request
    function sendEmail(form) {
        (0, http_1.postJson)("/contact", form).then(function () {
            var messageInput = document.getElementById("contact-message");
            document.getElementById("contact-status").classList.add("text-success");
            document.getElementById("contact-status").innerText = "Message sent!";
            messageInput.value = "";
            submitButton.disabled = false;
        }).catch(function () {
            document.getElementById("contact-status").classList.add("text-danger");
            document.getElementById("contact-status").innerText = "Failed to send message";
            submitButton.disabled = false;
        });
    }
    // Auto init
    init();
});
//# sourceMappingURL=/assets/javascripts/contact.js.map;
